/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * HiloReactComponent.tsx
 */

import React from "react";
import TranslationService, {TranslationListener} from "../../translation/TranslationService";
import DefaultPolicy from "../../provider/DefaultPolicy";
import Policy from "../../provider/Policy";
import Translation from "../../../services/translation/Translation";
import PolicyService, {PolicyListener} from "../../../services/PolicyService";
import ServiceRepository from "../../service/ServiceRepository";

export default class HiloReactComponent<P, S> extends  React.Component<P, S> implements TranslationListener, PolicyListener {

    protected readonly _serviceRepository: ServiceRepository;
    protected readonly _translationService: TranslationService;
    protected readonly _policyService: PolicyService;

    protected _policy: Policy = new DefaultPolicy();
    protected _t: Translation;

    public constructor(props: P, state: S) {
        super(props, state);

        this._serviceRepository = ServiceRepository.instance;

        this._translationService = this._serviceRepository.resolve(TranslationService.id) as TranslationService;
        this._policyService = this._serviceRepository.resolve(PolicyService.id) as PolicyService;

        this._t = this._translationService.translation;
    }

    /**
     * componentDidMount
     */
    public componentDidMount() {
        super.componentDidMount?.()
        this._translationService.addListener(this);
        this._policyService.addListener(this);
    }

    /**
     * componentWillUnmount
     */
    public componentWillUnmount() {
        super.componentWillUnmount?.()
        this._translationService.removeListener(this);
        this._policyService.removeListener(this);
    }

    get t() {
        return this._t;
    }

    /**
     * translationUpdated
     * @param t
     */
    public translationUpdated = (t: Translation) => {
        this._t = t;
        this.forceUpdate();
    };

    /**
     * policyUpdated
     * @param policy
     */
    public policyUpdated = (policy: Policy): void => {
        this._policy = policy;
    };
}